import { EntityUpgrades, Generator, GeneratorType, UpgradeType } from '../../types/game-types';

// Mapping of generator types to upgrade keys that modify ticksToGenerate
const ticksToGenerateUpgrades: Partial<Record<GeneratorType, keyof EntityUpgrades>> = {
  thief: UpgradeType.FastHands,
  // Add more generator types and their upgrade keys here as needed
  // Example:
  // wizard: 'someWizardUpgrade',
  // elf: 'someElfUpgrade',
};

export const getModifiedTicksToGenerate = (
  upgrades: EntityUpgrades,
  generator: Generator,
  generatorType: GeneratorType,
): number => {
  const baseTicksToGenerate = generator.ticksToGenerate ?? 1;

  // Check if this generator type has an upgrade that modifies ticksToGenerate
  const upgradeKey = ticksToGenerateUpgrades[generatorType];
  if (upgradeKey) {
    const upgrade = upgrades?.[upgradeKey];
    if (upgrade) {
      // multiplier already accumulates bonusPerOwned * purchased
      const reduction = upgrade.multiplier;
      return Math.max(1, baseTicksToGenerate + reduction); // Ensure minimum of 1
    }
  }

  return baseTicksToGenerate;
};
